@if (buttonType === 'outlined') {
  @if ((showFullNumber$ | async) === false) {
    <button
      class="gtm-contact-phone-reveal w-full"
      [angularticsAction]="revealAction"
      [angularticsLabel]="revealLabel"
      (click)="onReveal()"
      type="button"
      color="primary"
      mat-stroked-button
      angulartics2On="click"
      angularticsCategory="Contact Made"
      data-id="agent-phone-reveal">
      <ng-container *ngTemplateOutlet="revealNumberTemplate" />
    </button>
  } @else {
    <a
      class="w-full"
      [href]="'tel:' + phone"
      [angularticsAction]="callMadeAction"
      [angularticsLabel]="callMadeLabel"
      (click)="onCall()"
      mat-stroked-button
      color="primary"
      angulartics2On="click"
      angularticsCategory="Contact Made"
      data-id="agent-phone-call">
      <ng-container *ngTemplateOutlet="actualNumberTemplate" />
    </a>
  }
}

@if (buttonType === 'flat') {
  @if ((showFullNumber$ | async) === false) {
    <button
      class="gtm-contact-phone-reveal w-full"
      [angularticsAction]="revealAction"
      [angularticsLabel]="revealLabel"
      (click)="onReveal()"
      type="button"
      color="primary"
      mat-flat-button
      angulartics2On="click"
      angularticsCategory="Contact Made"
      data-id="agent-phone-reveal">
      <ng-container *ngTemplateOutlet="revealNumberTemplate; context: { $implicit: true }" />
    </button>
  } @else {
    <a
      class="w-full"
      [href]="'tel:' + phone"
      [angularticsAction]="callMadeAction"
      [angularticsLabel]="callMadeLabel"
      (click)="onCall()"
      mat-flat-button
      color="primary"
      angulartics2On="click"
      angularticsCategory="Contact Made"
      data-id="agent-phone-call">
      <ng-container *ngTemplateOutlet="actualNumberTemplate; context: { $implicit: true }" />
    </a>
  }
}

@if (buttonType === 'link') {
  @if ((showFullNumber$ | async) === false) {
    <button
      class="gtm-contact-phone-reveal font-bold text-blue-50"
      [angularticsAction]="revealAction"
      [angularticsLabel]="revealLabel"
      (click)="onReveal()"
      type="button"
      angulartics2On="click"
      angularticsCategory="Contact Made"
      data-id="agent-phone-reveal">
      <ng-container *ngTemplateOutlet="revealNumberTemplate; context: { $implicit: true, hideIcon: true }" />
    </button>
  } @else {
    <a
      class="text-blue-50 no-underline"
      [href]="'tel:' + phone"
      [angularticsAction]="callMadeAction"
      [angularticsLabel]="callMadeLabel"
      (click)="onCall()"
      angulartics2On="click"
      angularticsCategory="Contact Made"
      data-id="agent-phone-call">
      <ng-container *ngTemplateOutlet="actualNumberTemplate; context: { $implicit: true, hideIcon: true }" />
    </a>
  }
}

<ng-template #revealNumberTemplate let-flat let-hideIcon="hideIcon">
  <div class="flex items-center">
    @if (!hideIcon) {
      <rma-icon [class.!text-white]="flat" glyph="call" />
    }
    <span>{{ customLabel || (phone | shortText: 8) }}</span>
  </div>
</ng-template>

<ng-template #actualNumberTemplate let-flat let-hideIcon="hideIcon">
  <span class="flex items-center">
    @if (!hideIcon) {
      <rma-icon [class.!text-white]="flat" glyph="call" />
    }
    @if (isSmallDevice$ | async) {
      {{ 'button.label.call' | transloco }}
    } @else {
      {{ trackingPhone ?? phone }}
      @if (!trackingPhone) {
        <rma-trixel
          [trixelImgUrl]="trixelUrl"
          [trixelSourceCategory]="trixelRevealCategory"
          [trixelReferringSourceCategory]="trixelReferringCategory" />
      }
    }
  </span>

  @if (showCallTrixel$ | async) {
    <rma-trixel
      [trixelImgUrl]="trixelUrl"
      [trixelSourceCategory]="trixelCallCategory"
      [trixelReferringSourceCategory]="trixelReferringCategory" />
  }
</ng-template>
